import styled from 'styled-components';
import HeaderImage from '../../assets/header_img.png';

export const  HomeRoot = styled.div`
  position: relative;
  background-color: #ebebee;
  width: 100%;
  height: 100px;
  overflow: hidden;
  text-align: left;
  font-size: var(--font-size-base);
  color: var(--light-theme-595959);
  font-family: var(--font-product-sans);
`;
export const Image3Icon = styled.img`
  position: absolute;
  top: 153px;
  left: 79px;
  border-radius: 67px;
  width: 632px;
  height: 532px;
  object-fit: cover;
  mix-blend-mode: multiply;
`;
export const CarpadParent = styled.div`
  position: absolute;
  top: 34px;
  left: 32px;
  width: 165px;
  height: 40.08px;
  font-size: 24.09px;
  color: var(--color-black);
  font-family: var(--font-audiowide);
`;
export const Carpad = styled.div`
  position: absolute;
  top: 0px;
  left: 47px;
  text-transform: uppercase;
  color: #000;
    font-family: var(--font-audiowide);
font-size: 24.094px;
font-style: normal;
font-weight: 400;
line-height: normal;

`;
export const Slogan = styled.div`

  position: absolute;
  top: 25.05px;
  left: 49.02px;
  
  text-transform: uppercase;
  color: #838383;
  
font-family: Audiowide;
font-size: 9.423px;
font-style: normal;
font-weight: 400;
line-height: normal;
text-transform: uppercase;
`;
export const GroupItem = styled.img`
  position: absolute;
  height: 85.12%;
  width: 26.89%;
  top: 14.88%;
  right: 73.11%;
  bottom: 0%;
  left: 0%;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
`;
export const RectangleGroup = styled.div`
  position: relative;
  top: 40px;
  padding-right:150px;
  float:right;
  
  height: 28px;
  cursor: pointer;
  font-size: var(--font-size-xs);
  display:flex;
  flex-direction:row;
`;
export const GroupInner = styled.div`
  position: absolute;
  top: 0px;
  left: 484px;
  border-radius: 30px;
  background-color: var(--color-dodgerblue);
  width: 79px;
  height: 28px;
`;
export const LoginSection = styled.b`
position: absolute;
    top: 6px;
    left: 504px;
    color: var(--light-theme-ffffff-100);
`;
export const SelectedMenuLink = styled.b`
 position: relative;
 padding-left:30px;
  top: 6px;
  left: 0px;
  color: #000;
font-family: Product Sans;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: normal;
`;
export const MenuLink = styled.div`
 position: relative;
 padding-left:30px;
  top: 6px;
  left: 0px;
  color: #595959; 
font-family: Product Sans;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: normal;
`;
export const SelectedMenu = styled.div`
position: relative;
top: 2px;
left: 0px;
background-color: #4285f4;
width: auto;
height: 2px;
padding-left:30px;
`;
export const LoginText=styled.div`
color: #FFF;
font-family: Product Sans;
font-size: 12px;
font-style: normal;
font-weight: 700;

line-height: normal;`;
export const HeaderImgStyled = styled.img.attrs({ src: HeaderImage })``;
